import { setLocation } from 'utils/wrappers';

const pricing = {
  initialize() {
    this.setEventListeners();
  },
  selectPlan() {
    const id = $(this).data('planid');
    const quantity = $(this).data('planquantity');
    const name = $(this).data('planname');
    const price = $(this).data('planprice');
    const interval = $(this).data('planinterval');

    if(price && quantity && id) {
      const planData = JSON.stringify({ id, quantity, name, price, interval });
      window.sessionStorage.setItem('epsubplan', planData);
      setLocation('/checkout/confirmation');
    }
  },
  setEventListeners() {
    $('.btn-group').on('click', '.pricing-type:not(.active)', () => {
      $('.pricing-type, .pricing-list').toggleClass('active');
    });
    $('.pricing-list').on('click', '.product-selection', pricing.selectPlan)
  },
};

export default function () {
  // on load
  pricing.initialize();
}



// WEBPACK FOOTER //
// ./static-pages/pricing-plans.js